import { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { useSnapshot } from 'valtio';
import Summary from '../../elements/Summary/Summary';
import { toggleFiltersPanel } from '../actions/exclusions-filters-actions';
import ExclusionsStore from '../stores/exclusions-store';

const ExclusionsSummaryContainer: FC = () => {
  const { totalExclusions, totalFilteredExclusions } =
    useSnapshot(ExclusionsStore);

  return (
    <Summary
      headerText='Exclusions'
      navComponent={NavLink}
      count={totalFilteredExclusions}
      total={totalExclusions}
      onCollapse={toggleFiltersPanel}
    />
  );
};

export default ExclusionsSummaryContainer;
